import { useState } from "react";
import Sidebar from "../Components/AppComponents/Sidebar";
import BuilderTable from "../Components/AppComponents/BuilderComponents/BuilderTable";
import { Amplify } from "aws-amplify";
import amplifyconfig from "../amplifyconfiguration.json";
import { FaSun, FaMoon } from "react-icons/fa";

Amplify.configure(amplifyconfig);

function Builder() {
  const [whiteBg, setWhiteBg] = useState(false);

  return (
    <div
      style={{
        backgroundColor: whiteBg ? "#fff" : "var(--background-color)",
        color: "var(--textColor)",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Sidebar>
        <div style={{ marginTop: "1rem" }}>
          <button
            onClick={() => setWhiteBg((prev) => !prev)}
            style={{
              padding: "0.5rem",
              cursor: "pointer",
              borderRadius: "50%",
              background: "transparent",
              border: "none",
              fontSize: "1.5rem",
            }}
          >
            {whiteBg ? (
              <FaSun color="#fff" />
            ) : (
              <FaMoon color="#fff" />
            )}
          </button>
        </div>
      </Sidebar>

      {/* Main content area */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          paddingLeft: "15rem",
        }}
      >
        {sessionStorage.getItem("subscriptionStatus") === "true" ? (
          <BuilderTable />
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flex: 1,
              textAlign: "center",
            }}
          >
            <h2>
              A subscription is needed to access this feature. <br /> Please go
              to your account page to subscribe
            </h2>
          </div>
        )}
      </div>
    </div>
  );
}

export default Builder;
